import Swiper from 'swiper';
import { Navigation, Pagination, A11y, Autoplay, Keyboard } from 'swiper/modules';
const $ = window.jQuery;


const $DOM = {};


const domCache = () => {
    $DOM.container = $(".items-slider");
    if (!$DOM.container.length) {
        return;
    }
    $DOM.swiperContainer = $DOM.container.find(".upcoming-events-swiper-container");
    $DOM.counter = $DOM.container.find(".upcoming-events-counter");

}

const initSwiper = ($swiperContainer) => {

    const itemsSwiper = new Swiper($swiperContainer[0], {
        modules: [Navigation, Pagination, A11y, Autoplay, Keyboard],
        init: false,
        slidesPerView: 1.1,
        centeredSlides: false,
        spaceBetween: 18,
        preventInteractionOnTransition: false,
        speed: 750,
        preventClicksPropagation: false,
        roundLengths: true,
        loop: false,
        grabCursor: true,
        autoplay: false,
        a11y: true,
        navigation: false,
        keyboard: {
            enabled: true,
            onlyInViewport: true,
        },
        watchOverflow: true,
        pagination: {
            el: '.swiper-pagination',
            clickable: true
        },
        breakpoints: {
            768: {
                slidesPerView: 2.1,
                // navigation: {
                //     nextEl: '.swiper-next',
                //     prevEl: '.swiper-prev'
                // },
            },
            1024: {
                slidesPerView: 3,
            }
        }
    });

    const onInit = (swiperInstance) => {
        $swiperContainer.addClass("is-init");
    }

    const onActiveIndexChange = (swiperInstance) => {
    }

    itemsSwiper.on("init", onInit);
    itemsSwiper.on("activeIndexChange", onActiveIndexChange);
    itemsSwiper.init();

}


const itemsCarousel = {
    init: () => {

        $DOM.container = $(".items-carousel");
        if (!$DOM.container.length) {
            return;
        }

        $DOM.container.each(function() {
            const $swiperContainer = $(this).find(".swiper-container");
            initSwiper($swiperContainer);
        });

        domCache();
        if (!$DOM.container.length) {
            return;
        }
        initSwiper();
    }
};

export default itemsCarousel;
